export default __webpack_public_path__ + "static/media/motorcycle-dealer2.1a990a47.png";